import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SessionStore } from '../state/session.store';
import { LoadingIndicatorService } from '../services/loading-indicator.service';
import { GeolocationService } from '../services/geolocation.service';

const SESSION_TRACE_ID = crypto.randomUUID();

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionStore);
  const loading = inject(LoadingIndicatorService);
  const geolocation = inject(GeolocationService);

  const showLoading = !req.url.includes('/auth/access_token/shared-session/') && !req.url.includes('/auth/access_token/refresh/');

  let headers = req.headers
    .set('Accept-Language', session.language().toUpperCase())
    .set('X-Correlation-ID', crypto.randomUUID())
    .set('X-Trace-ID', SESSION_TRACE_ID);

  const coordinates = geolocation.getCoordinates();
  if (coordinates) {
    headers = headers.set('X-Client-Lat', String(coordinates.lat)).set('X-Client-Lng', String(coordinates.lng));
  }

  if (!headers.has('Accept')) {
    headers = headers.set('Accept', 'application/json');
  }
  const isFormData = req.body instanceof FormData;
  if (!isFormData && !headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  } else if (isFormData) {
    headers = headers.delete('Content-Type');
  }
  const token = session.accessToken();
  if (token && !headers.has('Authorization')) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  if (showLoading) {
    loading.increment();
  }

  return next(req.clone({ headers })).pipe(
    finalize(() => {
      if (showLoading) {
        loading.decrement();
      }
    }),
  );
};
